import { erpToast } from 'design-system/components/erp-toast'

const showError = (message: string | string[]) => {
 const messages = Array.isArray(message) ? message : [message]

 messages.forEach((msg) => {
 erpToast.error(msg)
 })
}

export default showError
